<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{ name: 'home' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Mutasi Saldo</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div
                class="section detail-transaction-section pt-2"
                style="--height:80px;"
            >
                <div class="detail-card text-center">
                    <h1 style="font-size:30px;" class="mt-2 mb-0">
                        <small style="font-size:15px;">Rp</small>
                        {{ customer.balance | rupiah }}
                    </h1>
                    <p class="mb-2">Sisa Utama</p>
                </div>
            </div>
            <div class="section mt-2 mb-2">
                <div class="card">
                    <div class="table-responsive">
                        <table
                            class="table rounded table-min"
                            style="font-size:11px;line-height:13px;"
                        >
                            <thead>
                                <tr
                                    style="background:rgba(233, 233, 236, 0.4);"
                                >
                                    <th scope="col">Keterangan</th>
                                    <th scope="col" class="text-right">
                                        Nominal
                                    </th>
                                    <th scope="col" class="text-right">
                                        Saldo
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="mutasi.data.length > 0">
                                <tr v-for="item in mutasi.data" :key="item.id">
                                    <td>
                                        <div style="font-weight: bold;">
                                            {{ dateMutation(item.created_at) }}
                                        </div>
                                        <div>{{ item.description }}</div>
                                    </td>
                                    <td class="text-right text-nowrap">
                                        <span
                                            :class="
                                                item.type == '+'
                                                    ? 'text-success'
                                                    : 'text-danger'
                                            "
                                            >{{ item.type }} Rp
                                            {{ item.nominal | rupiah }}</span
                                        >
                                    </td>
                                    <td
                                        class="text-right text-primary text-nowrap"
                                    >
                                        Rp {{ item.balance | rupiah }}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <thead>
                                    <tr>
                                        <td colspan="3" class="text-center">
                                            Data belum tersedia
                                        </td>
                                    </tr>
                                </thead>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="m-2 text-center" v-if="mutasi.next_page_url">
                    <ButtonLoader
                        :loading="loadingButton"
                        :styled="'btn btn-primary rounded mr-1 mb-1'"
                        @click.native="paginateMutasi(mutasi.next_page_url)"
                        >Lihat lebih banyak</ButtonLoader
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $axios from './../api.js';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    moment.locale('id');
    export default {
        data() {
            return {
                affiliate_id: '',
                loadingApp: true,
                loadingButton: false,
                mutasi: {
                    data: [],
                },
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
            dateMutation(date) {
                return moment(date).format('D MMM YYYY H:mm:ss');
            },
            paginateMutasi(url = '') {
                this.getCustomer();
                this.loadingButton = true;
                $axios
                    .get(url ? url : '/mutasi')
                    .then(response => {
                        if (!this.mutasi.data) {
                            this.mutasi = response.data.data;
                        } else {
                            this.mutasi.data.push(...response.data.data.data);
                            this.mutasi.next_page_url =
                                response.data.data.next_page_url;
                        }
                        this.loadingButton = false;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingButton = false;
                        this.loadingApp = false;
                    });
            },
        },
        mounted() {
            this.paginateMutasi();
        },
    };
</script>
<style>
    .table-min th,
    .table-min td {
        padding: 0.5rem 0.75rem 0.5rem 0.75rem;
    }
</style>
